export const SMS_MODE = 0;
export const CALL_MODE = 1;
export const WHATSAPP_MODE = 2;
